import React, { useState, useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { SelectInput } from "../../components/common/UI/Inputs/InputControls";
import DatePickerComponent from "../../components/common/UI/Inputs/InputControls/DateInput.jsx";
import TextInputForArchieve from "./TextInputForArchieve";
import { useSelector, useDispatch } from "react-redux";
import { archivedActions, myContactsActions, inboxActions } from "../../_store";
import { useNavigate, useLocation } from "react-router-dom";
import { getPastDate } from "../../utils/formatTime";
import { ReactNotifications } from "react-notifications-component";
import ConfirmationModal from "../../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import translations from '../../config/TranslateFile.jsx'
import {
  CreateEventLogTextFileForInbox,
  EventLog,
} from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import { getStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";

function Archived() {
  const [showSearchFields, setShowSearchFields] = useState(false);
  const [visibleCount, setVisibleCount] = useState(10);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();
  const { results, loading, error } = useSelector((state) => state.archived);
  const [resetTrigger, setResetTrigger] = useState(false);
  const [isPaymentMsg, setIsPaymentMsg] = useState(false);
  const [isPurchaseHistoryConfirm, setIsPurchaseHistoryConfirm] = useState(false);
  const [purchaseCreditInmateID, setPurchaseCreditInmateID] = useState(false);
  const [purchaseMessageId, setPurchaseMessageId] = useState(false);
  const [paymentMsg, setPaymentMsg] = useState("");
  const [popMessage, setPopMessage] = useState(null);
  const [confirmBtnName, setconfirmBtnName] = useState(null);
  const [cancelBtnName, setcancelBtnName] = useState(null);
  const dispatch = useDispatch();
  const [searchResult, setSearchResult] = useState(false);
  const [pendingSearch, setPendingSearch] = useState(null);
  const InmateDrpList = useSelector(
    (x) => x.myContacts.PublicMyContactsDisplayNew
  );
  const currentLang = translations();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  // const PublicInboxArchiveMessageSearch = useSelector((x) => x.archived.PublicInboxArchiveMessageSearch);
  const [filteredArchieveMessageList, setFilteredArchieveMessageList] = useState([]);
  const userID = getStoredValue("userID"); // PublicUserID get from local storage
  const defaultParams = useMemo(() => ({
    userID: userID,
    pageNo: 1,
    rowCountPerPage: 10,
    sortField: "",
  }), [userID]);
  const StatusOptions = [
    { label: currentLang?.DropDown?.All, value: 0 },
    { label: currentLang?.DropDown?.COD, value: 1 },
    { label: currentLang?.DropDown?.Read, value: 2 },
    { label: currentLang?.DropDown?.Unread, value: 3 },
  ];
  const RangeOptions = [
    { label: currentLang?.DropDown?.Last_one_Month, value: 1 },
    { label: currentLang?.DropDown?.Last_three_Months, value: 3 },
    { label: currentLang?.DropDown?.Last_6_Months, value: 6 },
    { label: currentLang?.DropDown?.Last_one_Year, value: 12 },
    { label: currentLang?.DropDown?.Custom, value: 0 },

  ];

  const UserID = getStoredValue("userID");

  useEffect(() => {
    if (!location.state?.findInboxMessage) {
      showLoader();
      const requestData = {
        UserID: UserID,
        InmateID: location.state?.findInboxMessage?.InmateID ? location.state?.findInboxMessage?.InmateID : 0,
        Month: 1,
        subject: "",
        FromDate: "",
        ToDate: "",
        MessageStatus: 0,
        PageNo: 1,
        RowCountPerPage: 10,
        SortField: ""
      };

      dispatch(archivedActions.PublicInboxArchiveMessageSearch(requestData)).then((response) => {
        hideLoader();
        if (response?.meta?.requestStatus === "fulfilled") {
          setFilteredArchieveMessageList(response.payload);
          setHasMoreData(true);
          if (response.payload.length < defaultParams?.rowCountPerPage) {
            setHasMoreData(false); // No more data available, hide "Load More"
          }
          if (response?.payload?.length === 0) {
            setSearchResult(true);
          }
        } else {
          setHasMoreData(false); // No more data available
        }

        const InfoMessage = "Load Archived Message List - " + defaultParams?.rowCountPerPage + " Records per page ";
        const Response = response?.payload || [];
        const Status = " Message Count - " + response?.payload?.length;

        CreateEventLogTextFileForInbox(
          dispatch,
          InfoMessage,
          "---",
          JSON.stringify(Response),
          Status
        );

      });

    }
    // restoreSearchState();

  }, [dispatch, resetTrigger]);

  // Function used for load inmate name
  useEffect(() => {
    let inmatesId = 0;
    // let userID = UserId;
    let userId = getStoredValue("userID");
    let activeStatus = 0;
    let sortField = "InmateName asc";
    let inmateLoadPurpose = "All";
    dispatch(
      myContactsActions.PublicMyContactsDisplayNew({
        userId,
        inmatesId,
        inmateLoadPurpose,
        activeStatus,
        sortField,
      })
    );
  }, [dispatch]);

  const [formData, setFormData] = useState({
    InmateID: 0,
    subject: "",
    status: 0,
    range: 1,
    fromDate: "",
    toDate: getPastDate(31),
    month: 1,
    pageNo: 1,
    rowCountPerPage: 10,
    StatusOptions: null,
  });

  const resetForm = () => {
    navigate(location.pathname, {
      replace: true,
      state: {
        findInboxMessage: null,
        filteredArchieveMessageList: null,
        pageNo: null
      },
    });

    const requestData = {
      UserID: UserID,
      InmateID: location.state?.findInboxMessage?.InmateID ? location.state?.findInboxMessage?.InmateID : 0,
      Month: 1,
      subject: "",
      FromDate: "",
      ToDate: "",
      MessageStatus: 0,
      PageNo: 1,
      RowCountPerPage: 10,
      SortField: ""
    };

    dispatch(archivedActions.PublicInboxArchiveMessageSearch(requestData)).then((response) => {
      hideLoader();
      if (response?.meta?.requestStatus === "fulfilled") {
        setFilteredArchieveMessageList(response.payload);
        setHasMoreData(true);
        if (response.payload.length < defaultParams?.rowCountPerPage) {
          setHasMoreData(false); // No more data available, hide "Load More"
        }
        if (response?.payload?.length === 0) {
          setSearchResult(true);
        }
      } else {
        setHasMoreData(false); // No more data available
      }

      const InfoMessage = "Reset Button clicked in  Archived Message List - " + formData?.rowCountPerPage + " Records per page";
      const Response = response?.payload || [];
      const Status = " Message Count - " + response?.payload?.length;

      CreateEventLogTextFileForInbox(
        dispatch,
        InfoMessage,
        "---",
        JSON.stringify(Response),
        Status
      );
    });

    setFormData({
      InmateID: 0,
      subject: "",
      status: 0,
      range: 1,
      fromDate: "",
      toDate: getPastDate(31),
      month: 1,
      pageNo: 1,
      rowCountPerPage: 10,
      StatusOptions: null,
    });
    setResetTrigger([resetTrigger])
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };


  const handleSelectChange = (selectedOption, fieldName) => {
    const selectedValue = Array.isArray(selectedOption)
      ? selectedOption.map((option) => option.value)
      : selectedOption?.value ?? "";

    if (fieldName === "range") {
      setFormData((prevState) => ({
        ...prevState,
        fromDate: "",
        toDate: getPastDate(31),
      }));
    }

    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: selectedValue != null && selectedValue != "" ? selectedValue : 0, // Store the updated value for the field
    }));
  };

  const handleClickRedirect = (event, message, type) => {
    event.stopPropagation();  // Prevent event from bubbling up
    if (type === "COD") {
      setcancelBtnName(currentLang?.buttons?.Cancel);
      setPopMessage(currentLang?.ArchivedPagePopContent?.CODMessage);
      setconfirmBtnName(currentLang?.buttons?.BuyCredits);
    }
    else {
      setcancelBtnName(currentLang?.buttons?.No);
      setPopMessage(currentLang?.ArchivedPagePopContent?.Redirect_Page);
      setconfirmBtnName(currentLang?.buttons?.Yes);
    }
    setIsPurchaseHistoryConfirm(true);
    setPurchaseCreditInmateID(message.InmateID);
    setPurchaseMessageId(message.MessageID)
  };

  const handlePaymentMsg = () => {
    setIsPaymentMsg(false);
  };
  const handleSearch = (from, InmateIDFilter) => {
    showLoader();
    let page = 1;
    const rowPerPage = 10;
    setSearchResult(true);
    if (from === "loadmore") {
      page = pageNo + 1;
      setPageNo(page);
    } else {
      setFilteredArchieveMessageList([]);
      setPageNo(1); // Reset page number for a new search
    }

    if (!formData?.toDate) {
      setFormData((prevState) => ({
        ...prevState,
        toDate: getPastDate(31)
      }))
    }
    const requestData = {
      UserID: UserID,
      InmateID: InmateIDFilter !== null && InmateIDFilter != undefined ? InmateIDFilter : formData?.InmateID,
      Month: formData?.range,
      subject: formData?.subject,
      FromDate: !formData?.fromDate ? "" : formatDate(formData?.fromDate),
      ToDate: !formData?.toDate ? formatDate(getPastDate(31)) : formatDate(formData?.toDate),
      MessageStatus: formData?.status,
      PageNo: page,
      RowCountPerPage: rowPerPage,
      SortField: "",
    };

    dispatch(archivedActions.PublicInboxArchiveMessageSearch(requestData)).then((response) => {
      hideLoader();
      if (response?.meta?.requestStatus === "fulfilled") {
        // if (from !== "loadmore"){
        // setFilteredArchieveMessageList([]);
        // }
        const responseData = response.payload || [];
        setFilteredArchieveMessageList((prev) => [...prev, ...responseData]);

        if (responseData.length < rowPerPage) {
          setHasMoreData(false);
        } else {
          setHasMoreData(true);
        }
      } else {
        setHasMoreData(false);
      }

      const InfoMessage = "Searched Archived Message List Using - InmateID " + formData?.InmateID + " MessageSubject-" + formData?.subject + "FromDate" + formData?.fromDate + "ToDate" + formData?.toDate + "Status" + formData?.status;
      const Response = response?.payload || [];
      const Status = " Message Count - " + response?.payload?.length;

      CreateEventLogTextFileForInbox(
        dispatch,
        InfoMessage,
        "---",
        JSON.stringify(Response),
        Status
      );

    });
  };

  // On return to Inbox page
  useEffect(() => {
    if (location.state?.findInboxMessage) {
      setPageNo(location.state?.pageNo || 1);
      setFilteredArchieveMessageList(location.state?.filteredArchieveMessageList || []);
      setFormData((prev) => ({
        ...prev,
        ...location.state?.findInboxMessage,
      }));
      setPendingSearch(location.state?.findInboxMessage?.InmateID);
    }
    // else if (!location.state?.findInboxMessage) {
    //   resetForm();
    // }
  }, []);

  useEffect(() => {
    if (pendingSearch !== null) {
      setShowSearchFields(true);
      handleSearch("", pendingSearch);
      setPendingSearch(null); // Reset after execution
    }
  }, [pendingSearch]);

  const handleClick = (messages) => {
    let PUIConnectionIDArray = InmateDrpList.filter(
      (item) => item.InmateID === messages?.InmateID
    );
    let PUIConnectionID =
      PUIConnectionIDArray.length > 0
        ? PUIConnectionIDArray[0].PUIConnectionID
        : null; // Handle empty result

    navigate("/public/Messenger", {
      state: {
        MessageID: messages?.MessageID,
        PublicUserID: messages?.PublicUserID,
        CODMessageCount: messages?.CODMessageCount,
        PUIConnectionID: PUIConnectionID,
        from: location.pathname,
        findInboxMessage: formData,
        pageNo: pageNo,
        filteredArchieveMessageList: filteredArchieveMessageList,
      },
    });
    setFilteredArchieveMessageList(PUIConnectionIDArray)
    storeCurrentRoute("/public/Messenger");
  }

  const formatDate = (date) => {
    if (date !== null) {
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, '0'); // Get month and pad with leading zero if necessary
      const day = String(d.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
      const year = d.getFullYear(); // Get the full year
      return `${month}/${day}/${year}`; // Return the formatted date
    }
    else {
      return null;
    }
  };

  const handleDateChange = (e, field) => {
    const formattedDate = e ? formatDate(e.toLocaleDateString('en-CA')) : ""; // Format as YYYY-MM-DD
    const isValidDate = e instanceof Date && !isNaN(e.getTime()) && e.getFullYear() >= 1990;
    if (!isValidDate || formattedDate === "") {
      setFormData((prevState) => ({
        ...prevState,
        [field]: "", // Clear the specific field if invalid
      }));
    } else {
      if (field === "fromDate") {
        if (formData.toDate && new Date(formattedDate) > new Date(formData.toDate)) {
          setFormData((prevState) => ({
            ...prevState,
            [field]: "", // Clear fromDate if it's greater than ToDate
          }));
        } else {
          setFormData((prevState) => ({
            ...prevState,
            [field]: formattedDate, // Set valid FromDate
          }));
        }
      } else if (field === "toDate") {
        if (
          (formData.fromDate && new Date(formattedDate) < new Date(formData.fromDate)) ||
          new Date(formattedDate) > new Date(new Date().setMonth(new Date().getMonth() - 1)) // Ensure max is one month before current date
        ) {
          setFormData((prevState) => ({
            ...prevState,
            [field]: "", // Clear ToDate if invalid
          }));
        } else {
          setFormData((prevState) => ({
            ...prevState,
            [field]: formattedDate, // Set valid ToDate
          }));
        }
      }
    }
  };

  const handleBlur = (e, field) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (field === "fromDate") {
      if (formData?.toDate && new Date(value) > new Date(formData?.toDate)) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (field === "toDate") {
      if (formData?.fromDate && new Date(value) < new Date(formData?.fromDate)) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = field === "fromDate" ? new Date(2017, 0, 1) : formData?.fromDate ? new Date(formData?.fromDate) : new Date(2017, 0, 1);
    const maxDate = field === "fromDate" ? formData?.toDate && !isNaN(new Date(formData.toDate).getTime()) ? new Date(getPastDate(31)) : new Date(getPastDate(31)) : getPastDate(31);
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= new Date(maxDate);

    let updatedParam = {
      ...formData,
      fromDate:
        field === "fromDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : formData?.fromDate, // preserve existing value
      toDate:
        field === "toDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : formData?.toDate, // preserve existing value
    };
    setFormData(updatedParam);

  };


  const handleCancelPurchaseHist = () => {
    setIsPurchaseHistoryConfirm(false);
  };

  // PurchaseCredit Redirect
  const handleClickPurchaseCreditRedirect = () => {
    const requestData = {
      userId: userID,
      inmateId: purchaseCreditInmateID,
      messageId: purchaseMessageId,
    };

    dispatch(inboxActions.PublicInboxMessageSubjectPurchaseDisabled(requestData)).then((response) => {
      const { Result, Notes } = response?.payload;
      setIsPurchaseHistoryConfirm(false);
      // LoadSentPhotos();
      switch (Result) {
        case -7:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Connection_Blocked);
          setIsPaymentMsg(true);
          handleSearch();
          break;
        case -8:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.No_longer_connected);
          setIsPaymentMsg(true);
          handleSearch();
          break;
        case -6:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Contact);
          setIsPaymentMsg(true);
          handleSearch();
          break;
        case -4:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Facility);
          setIsPaymentMsg(true);
          handleSearch();
          break;
        case -3:
          setPaymentMsg(Notes);
          setIsPaymentMsg(true);
          break;
        default:
          if (Result === 0) {
            setStoredValue("InmateID", purchaseCreditInmateID);
            navigate("/public/PurchaseCredits", {
              state: { previousPath: location.pathname },
            });
            storeCurrentRoute("/public/PurchaseCredits");
            //  dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());

          }
          break;
      }

    })

  };

  return (
    <>
      <ReactNotifications />
      <div className="">
        <div className="header-title">
          <h5>
            {/* <i className="fa fa-archive me-2"></i> */}
            {currentLang?.Archived}
          </h5>
        </div>
      </div>
      <div className="row mb-5 pb-mobile">
        <div className="col-md-12">
          <ul className="list-group" id="divLoadList">
            <div className="card w-100 border-radius-all shadow-sm ">
              <div
                className="card-header d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleInformation}
              >
                <h4 className="mb-0 text-dark">
                  <i
                    className="fa fa-search me-2"
                    style={{ fontSize: "16px" }}
                  ></i>
                  {currentLang?.header?.Search}
                </h4>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                    }`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>

              {showSearchFields && (

                <div className="card-body bg-white padding-20">
                  <div className="row">
                    <div className="col-lg-3 col-md-6 mb-2">
                      <SelectInput
                        options={InmateDrpList}
                        value={formData.InmateID}
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "InmateID")
                        }
                        name="InmateID" // Make sure the name is passed
                        labelKey="label"
                        valueKey="value"
                        isClearable={true}
                        placeholder={currentLang?.placeholders?.cmbInmate}
                        label={currentLang?.labels?.Inmate}
                        required={true}
                      //  isDisabled={isDisabledInmateID}
                      // errorMessage={errors.Inmate} // Make sure this is correctly passed
                      />
                    </div>
                    <div className="col-lg-3 col-md-6 mb-2">
                      <TextInputForArchieve
                        name="subject"
                        id="subject"
                        label={currentLang?.labels?.Subject}
                        value={formData.subject}
                        placeholder={currentLang?.labels?.Subject}
                        onChange={(e) =>
                          setFormData((prevState) => ({
                            ...prevState,
                            subject: e.target.value,
                          }))
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSearch();
                          }
                        }}
                      />
                    </div>
                    <div className="col-lg-3 col-md-6 mb-2">
                      <SelectInput
                        options={StatusOptions}
                        value={formData.status}
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "status")
                        }
                        name="Status"
                        labelKey="label"
                        valueKey="value"
                        isClearable={false}
                        placeholder=""
                        label={currentLang?.labels?.Status}

                      />
                    </div>
                    <div className="col-lg-3 col-md-6 mb-2">
                      <SelectInput
                        name="range"
                        options={RangeOptions}
                        // placeholder={RangeOptions[0]?.label}
                        label={currentLang?.labels?.Range}
                        labelKey="label"
                        valueKey="value"
                        isClearable={false}
                        value={formData.range}
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "range")
                        }
                      />
                    </div>
                  </div>

                  {formData.range === 0 && (
                    <div className="row mt-2">
                      <div className="col-lg-3 col-md-6 mb-4">
                        <DatePickerComponent
                          value={formData.fromDate}
                          maxDate={
                            formData?.toDate && !isNaN(new Date(formData.toDate).getTime()) // Check if toDate is valid
                              ? new Date(getPastDate(31)) // Use toDate if it exists
                              : new Date(getPastDate(31)) // Default to one month before today
                          }
                          onChange={(date) => handleDateChange(date, "fromDate")}
                          onBlur={(e) => handleBlur(e, "fromDate")}
                          name="FromDate"
                          label={currentLang?.ArchivedPage?.FromDate}
                          required={false}
                          disabled={false}
                          yearDropDown={true}
                          monthDropDown={true}
                          showTimeSelect={false}
                          clearOption={false}
                          onCopy={(e) => e.preventDefault()} // Restrict copy
                          onPaste={(e) => e.preventDefault()} // Restrict paste
                          onCut={(e) => e.preventDefault()} // Restrict cut
                          minDate={new Date(2017, 0, 1)} // Set minimum date to January 1, 2017
                        />

                      </div>
                      <div className="col-lg-3 col-md-6 mb-4">
                        <DatePickerComponent
                          value={formData.toDate}
                          minDate={formData?.fromDate ? new Date(formData?.fromDate) : new Date(2017, 0, 1)} // Ensure min is FromDate
                          maxDate={getPastDate(31)} // Restrict to one month before current date
                          onChange={(date) => handleDateChange(date, "toDate")}
                          onBlur={(e) => handleBlur(e, "toDate")}
                          name="ToDate"
                          label={currentLang?.ArchivedPage?.ToDate}
                          required={false}
                          disabled={false}
                          yearDropDown={true}
                          monthDropDown={true}
                          showTimeSelect={false}
                          onCopy={(e) => e.preventDefault()} // Restrict copy
                          onPaste={(e) => e.preventDefault()} // Restrict paste
                          onCut={(e) => e.preventDefault()} // Restrict cut
                        />
                      </div>
                    </div>

                  )}
                  <div className="text-center mt-1">
                    <div className="d-flex justify-content-start flex-wrap mt-1">
                      <button
                        type="submit"
                        className="btn btn-success me-2 font-size-14 mb-2"
                        onClick={handleSearch}
                      >
                        <i className="fa-solid fa-magnifying-glass me-1"></i>
                        {currentLang?.buttons?.Search}
                      </button>
                      <button type="button" className="btn btn-grey me-2 font-size-14 mb-2" onClick={resetForm}>
                        <i className="fa-solid fa-arrow-rotate-left me-1"></i>
                        {currentLang?.buttons?.Reset}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <ul className="list-group mt-3 border-radius-all shadow-sm">
              {loading ? (
                <div className="alert alert-info text-center" role="alert">
                  {currentLang?.ArchivedPage?.Loading}
                </div>
              ) : filteredArchieveMessageList && filteredArchieveMessageList.length > 0 ? (
                filteredArchieveMessageList.map((message) => (
                  <li
                    key={message.MessageID}
                    className="list-group-item d-flex align-items-center justify-content-between flex-wrap cursor-pointer"
                    onClick={() => handleClick(message)}            >
                    <div className="d-flex align-items-center m-w-100 mo-mb-10">
                      <i
                        className="fa fa-user-circle fa-2x text-dark me-3"
                        style={{ fontSize: "30px", position: "relative" }}
                      ></i>
                      {message.MessageStatus !== "Read" &&
                        <span
                          className="me-3 notificationBadge animate-blink"
                          style={{
                            position: "absolute",
                            top: "9px",
                            left: "36px",
                            //  backgroundColor: "#4a9a93",
                            //  color: "#FFFFFF",
                            borderRadius: "50%",
                            // padding: "3px 8px",
                            fontSize: "10px",
                            fontWeight: "bold",
                            display: "flex",
                            width: "22px",
                            height: "22px",
                            justifyContent: "center",
                            alignItems: "center",

                          }}
                        >
                          {message.PublicUserUnreadCount}
                        </span>
                      }
                      <div>
                        <label className="fw-bold mb-0 profile-Name">{message.MessageFrom}</label>
                        <br />
                        <span className="text-muted msg-desc hidden-text">{message.MessageSubject}</span>
                      </div>
                    </div>
                    <div className="justify-content-end">
                      <span className="text-gray-date float-right position-mobile">{message.MessageSendDateTime}</span>

                      <div className="d-flex justify-content-end align-items-center flex-wrap">

                        {message.CODMessageCount > 0 && (
                          <div className="d-flex align-items-center">
                            <button
                              type="button"
                              title={currentLang?.buttons?.CODMessage}
                              className="btn btn-danger btn-sm ml-10 mb-1"
                              style={{ padding: "4px 8px" }}
                              onClick={(event) =>
                                handleClickRedirect(event, message, "COD")
                              }
                            >
                              {currentLang?.buttons?.CODMessage}
                            </button>
                          </div>
                        )}

                        <div className="d-flex align-items-center">
                          {message.IsAllowSendReply !== 0 && message.Blocked !== 1 && (<button
                            id="btnBuyCredits"
                            type="button"
                            title={currentLang?.buttons?.BuyCredits}
                            className="btn btn-success btn-sm ml-10 pad-4 mb-1"
                            onClick={(event) =>
                              handleClickRedirect(event, message)
                            }
                          >
                            {currentLang?.buttons?.BuyCredits}
                          </button>)}
                        </div>

                        <div className="d-flex align-items-center justify-content-center">
                          <button className="btn btn-blue btn-sm min-width-80 ml-10 cursor-default mb-1">
                            <h5 className="available-limit text-white">
                              ${message.CreditBalance?.toFixed(2) || "0.00"}
                            </h5>
                          </button>
                        </div>


                      </div>
                    </div>
                  </li>
                ))
              ) : searchResult && (
                <div className="alert-light-red mb-3 font-size-16 p-3 text-center">
                  {currentLang?.NO_Data_Found}
                </div>
              )}
              {hasMoreData && filteredArchieveMessageList.length > 0 && (
                <li className="list-group-item">
                  <div className="d-flex justify-content-center mb-n3">
                    <div className="div-load-more-data inbox panel footer-load-more">
                      <label
                        className="text-decoration-none text-danger fs-5 cursor-pointer load-more-button"
                        onClick={() => { handleSearch("loadmore") }}
                      >
                        <i class="fa-solid fa-plus me-1 font-size-14"></i>{currentLang?.buttons?.LoadMore}
                      </label>
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </ul>
        </div>
      </div>
      {loader}
      <ConfirmationModal
        show={isPurchaseHistoryConfirm}
        onHide={handleCancelPurchaseHist}
        onConfirm={handleClickPurchaseCreditRedirect}
        title={currentLang?.Message}
        message={popMessage || "This action redirects into another page, Are you sure you want to proceed?"}
        closeButton={false}
        onconfirmname={confirmBtnName || currentLang?.buttons?.Yes}
        oncancelname={cancelBtnName || currentLang?.buttons?.No}
      />
      <ConfirmationModal
        show={isPaymentMsg}
        onHide={handlePaymentMsg}
        onConfirm={handlePaymentMsg}
        title={currentLang?.Message}
        message={paymentMsg}
        showCancelButton={false}
        closeButton={false}
        onconfirmname={currentLang?.buttons?.OK}
      />


    </>
  );
}

export default React.memo(Archived);
